import React, { useState, useEffect } from 'react'
import Grid from '../components/Grid/Grid.js'
import NavBar from '../components/NavBar/NavBar.js'
import NavPane from '../components/NavPane/NavPane.js'
import { supabase } from '../supabaseClient'
import { useSelector } from 'react-redux'

const Liked = () => {
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(true)
  
  const isLogged = useSelector(state => state?.user?.isLoggedIn)
  const userState = useSelector(state => state?.user)

  // Get active username/user_id directly matching VideoPlayer logic
  const getUserId = () => {
    const u = userState?.user || userState?.userInfo || userState

    if (u?.username && u.username !== 'null') return String(u.username).trim()
    if (u?.user_id && u.user_id !== 'null') return String(u.user_id).trim()
    if (u?.id && u.id !== 'null') return String(u.id).trim()
    if (typeof u === 'string' && u !== 'null' && u !== '[object Object]') return u.trim()

    try {
      const stored = JSON.parse(localStorage.getItem('user'))
      if (stored?.username) return String(stored.username).trim()
      if (stored?.user_id) return String(stored.user_id).trim()
      if (stored?.id) return String(stored.id).trim()
    } catch (e) {}

    const directUser = localStorage.getItem('username') || localStorage.getItem('currentUser')
    return directUser ? String(directUser).trim() : null
  }

  const activeUser = getUserId()

  useEffect(() => {
    const fetchLikedVideos = async () => {
      setLoading(true)

      if (!activeUser) {
        console.warn("No logged in user found for Liked page.")
        setVideos([])
        setLoading(false)
        return
      }

      console.log("Fetching likes for user:", activeUser)

      try {
        // 1. Fetch profile matching user_id (case-insensitive search)
        const { data: profiles, error: profileErr } = await supabase
          .from('profiles')
          .select('liked_videos')
          .ilike('user_id', activeUser)

        if (profileErr) console.error("Profile fetch error:", profileErr)

        const profile = profiles?.[0]
        const rawIds = profile?.liked_videos || []
        console.log("Raw liked_videos array from DB:", rawIds)

        if (!Array.isArray(rawIds) || rawIds.length === 0) {
          setVideos([])
          setLoading(false)
          return
        }

        // Prepare both numeric and string versions of IDs to support all primary key types
        const numericIds = rawIds.map(id => Number(id)).filter(id => !isNaN(id))
        const stringIds = rawIds.map(String)
        const queryIds = [...new Set([...numericIds, ...stringIds])]

        // 2. Fetch matching video records from 'videos' table
        const { data: videoData, error: videoErr } = await supabase
          .from('videos')
          .select('*')
          .in('id', queryIds)

        if (videoErr) {
          console.error("Video fetch error:", videoErr)
          setVideos([])
        } else {
          console.log("Fetched video objects:", videoData)
          setVideos(videoData || [])
        }
      } catch (err) {
        console.error("Failed to load liked videos:", err)
      } finally {
        setLoading(false)
      }
    }

    fetchLikedVideos()
  }, [isLogged, activeUser])

  return (
    <div className="w-full h-full flex flex-col overflow-hidden">
      <NavBar activePage={"Liked"} />
      
      <div className="flex flex-row pt-5 flex-1 w-full h-full overflow-hidden">
        <NavPane activePage={"Liked"} />
        
        <div className="flex-1 p-4 overflow-y-auto">
          {loading ? (
            <div className="text-2xl font-semibold text-gray-600 w-fit relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              Loading...
            </div>
          ) : videos.length === 0 ? (
            <div className="text-2xl font-semibold text-gray-600 w-fit relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              No liked videos
            </div>
          ) : (
            <Grid videos={videos} setVideos={setVideos} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Liked
